
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { blogPosts, blogCategories } from '../../../mocks/blogPosts';

export default function BlogGrid() {
  const [activeCategory, setActiveCategory] = useState('Todos');

  const filteredPosts = activeCategory === 'Todos'
    ? blogPosts
    : blogPosts.filter(post => post.category === activeCategory);

  return (
    <section className="py-16 sm:py-20 bg-dark">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4">
            Todos os <span className="text-accent-green">Artigos</span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto">
            Explore nosso conteúdo sobre inteligência artificial, automação e transformação digital
          </p>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {blogCategories.map((category) => (
            <button
              key={category.name}
              onClick={() => setActiveCategory(category.name)}
              className={`px-5 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                activeCategory === category.name
                  ? 'bg-accent-green text-black'
                  : 'bg-dark-secondary text-gray-300 hover:bg-dark-secondary/80 hover:text-white'
              }`}
            >
              {category.name}
              <span className="ml-2 opacity-60">({category.count})</span>
            </button>
          ))}
        </div>

        {/* Posts Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {filteredPosts.map((post, index) => (
            <Link
              key={post.id}
              to={`/blog/${post.slug}`}
              className="group bg-dark-secondary rounded-2xl overflow-hidden cursor-pointer hover:shadow-xl hover:shadow-accent-green/5 transition-all duration-300 hover:-translate-y-1"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              {/* Image */}
              <div className="relative h-52 overflow-hidden">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-dark-secondary to-transparent opacity-60" />
                <div className="absolute top-4 left-4">
                  <span className={`${post.categoryColor} text-black px-3 py-1 rounded-full text-xs font-bold`}>
                    {post.category}
                  </span>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="text-lg font-bold text-white mb-3 group-hover:text-accent-green transition-colors line-clamp-2">
                  {post.title}
                </h3>
                <p className="text-gray-400 text-sm mb-4 line-clamp-3">
                  {post.excerpt}
                </p>

                {/* Meta */}
                <div className="flex items-center justify-between pt-4 border-t border-dark-border">
                  <div className="flex items-center gap-3">
                    <img
                      src={post.authorAvatar}
                      alt={post.author}
                      className="w-8 h-8 rounded-full object-cover"
                    />
                    <span className="text-gray-300 text-sm">{post.author}</span>
                  </div>
                  <div className="flex items-center gap-2 text-gray-500 text-xs">
                    <i className="ri-time-line"></i>
                    <span>{post.readTime}</span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* Load More Button */}
        <div className="text-center mt-12">
          <button className="inline-flex items-center gap-2 bg-dark-secondary hover:bg-dark-secondary/80 text-white px-8 py-4 rounded-full font-medium transition-colors cursor-pointer whitespace-nowrap">
            <span>Carregar Mais Artigos</span>
            <i className="ri-arrow-down-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
